// Router
import { createLink } from "@tanstack/react-router"

// UI primitives
import { BreadcrumbLink as BreadcrumbLinkPrimitive } from "@/components/ui/breadcrumb"

export {
  BREADCRUMB_LIST_APP_CLASS,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"

/**
 * Router-bound BreadcrumbLink: `to`/`params`/`search` are type-checked against
 * the app route tree. For router-less contexts (Storybook, plain `<a>`) use the
 * primitive from "@/components/ui/breadcrumb".
 */
export const BreadcrumbLink = createLink(BreadcrumbLinkPrimitive)
